import axios from 'axios';
import dotenv from 'dotenv';

dotenv.config();

export const LAST_FM = axios.create({
  baseURL: process.env.VUE_APP_API_LASTFM_URI,
  timeout: 60000,
});

export const searchAlbumLastFM = async (albumName) => {
  const { data } = await LAST_FM.get('', {
    params: {
      method: 'album.search',
      album: albumName,
      api_key: process.env.VUE_APP_API_LASTFM_KEY,
      format: 'json',
    },
  });
  return data.results.albummatches.album;
};

export const searchArtist = async (artistName) => {
  const { data } = await LAST_FM.get('', {
    params: {
      method: 'artist.search',
      artist: artistName,
      api_key: process.env.VUE_APP_API_LASTFM_KEY,
      format: 'json',
    },
  });
  return data.results.artistmatches.artist;
};

export const getAlbumInfoLastFM = async (id, artist, album) => {
  const params = {
    method: 'album.getinfo',
    api_key: process.env.VUE_APP_API_LASTFM_KEY,
    format: 'json',
  };
  if (id) {
    params.mbid = id;
  } else if (artist || album) {
    params.artist = artist;
    params.album = album;
  } else {
    return false;
  }
  const { data } = await LAST_FM.get('', {
    params,
  });
  return data.album;
};

export default LAST_FM;
